import {DocumentIcon, PersonIcon, SettingsIcon, StatsIcon,} from "components/Icons/Icons";

import {
  FiAlertTriangle,
  FiBook,
  FiCheck,
  FiCreditCard,
  FiHelpCircle,
  FiList,
  FiPaperclip,
  FiBarChart2,
  FiPieChart,
  FiPrinter,
  FiSearch,
  FiUserCheck,
  FiFileText,
} from 'react-icons/fi';

import {
  FaBalanceScale,
  FaBars,
  FaBook,
  FaBus,
  FaCar,
  FaCarCrash,
  FaClock,
  FaMobile,
  FaQq,
  FaRoad,
  FaSearch,
  FaTaxi,
  FaUser,
  FaUsers,
  FaVideo,
  FaWheelchair,
  FaWpforms,
  FaHistory,
} from 'react-icons/fa';

import {CheckCircleIcon} from "@chakra-ui/icons";
import IconWithBadge from "./components/CustomIcon/IconWithBadge";
import DataTables from "views/Applications/DataTables";
import SignInCover from "views/Authentication/SignIn/SignInCover.js";
import {ROUTES} from "constants/routes-path";
import { PERMISSIONS, PROFILES } from "constants/permission";
import {
  ENABLE_CONSULTA_CONDUTORES_DETRAN_MENU,
  ENABLE_CONSULTA_VEICULO_DETRAN_MENU,
  ENABLE_CONSULTAS_MENU,
  ENABLE_CONSULTAS_SENATRAN_MENU,
  ENABLE_CARTOES_MENU,
  ENABLE_STATISTICS_MENU,
  ENABLE_CONSULTA_HISTORICO_MULTAS_CONDUTORES_DETRAN_MENU,
  ENABLE_CONSULTA_PROCESSO_BLOQUEIO_CONDUTORES_DETRAN_MENU,
  ENABLE_CONSULTA_HISTORICO_INFRACAO_DETRAN_MENU,
  ENABLE_BOAT,
} from "constants/config";
import TrafficViolationList from "views/Pages/TrafficViolation/TrafficViolationList";
import TrafficViolationNew from "views/Pages/TrafficViolation/TrafficViolationNew";
import ParametersList from "views/Pages/Parameters/ParametersList";
import ParametersEdit from "views/Pages/Parameters/ParametersEdit";
import CamerasList from "views/Pages/Cameras/CamerasList";
import CameraNew from "views/Pages/Cameras/CameraNew";
import CameraEdit from "views/Pages/Cameras/CameraEdit";
import BreathalyzersList from "views/Pages/Breathalyzers/BreathalyzersList";
import BreathalyzerNew from "views/Pages/Breathalyzers/BreathalyzerNew";
import BreathalyzerEdit from "views/Pages/Breathalyzers/BreathalyzerEdit";
import ViolationAllotmentsValidationList
  from "views/Pages/ViolationAllotmentsValidation/ViolationAllotmentsValidationList";
import ViolationAllotmentsViolationList
  from "views/Pages/ViolationAllotmentsValidation/ViolationAllotmentsViolationList";
import ViolationAllotmentValidate from "views/Pages/ViolationAllotmentsValidation/ViolationAllotmentValidate";
import EquipmentsList from "views/Pages/Equipments/EquipmentsList";
import EquipmentNew from "views/Pages/Equipments/EquipmentNew";
import AgentsList from "views/Pages/Agents/AgentsList";
import AgentNew from "views/Pages/Agents/AgentNew";
import AgentDetails from "views/Pages/Agents/AgentDetails";
import UserList from "views/Pages/Users/UserList";
import UserNew from "views/Pages/Users/UserNew";
import UserDetails from "views/Pages/Users/UserDetails";
import PrintNPsList from "views/Pages/PrintNPs/PrintNPsList";
import PrintNAsList from "views/Pages/PrintNAs/PrintNAsList";
import ProcessesList from "./views/Pages/Processes/ProcessesList";
import ProcessNew from "./views/Pages/Processes/ProcessNew";
import AitBlocksList from "views/Pages/AitBlocks/AitBlocksList";
import AitBlockNew from "views/Pages/AitBlocks/AitBlockNew";
import PersonList from "views/Pages/Person/PersonList";
import PersonEditor from "views/Pages/Person/PersonEditor";
import AuditList from "views/Pages/Audit/AuditList";
import AgentsSchedulesList from "views/Pages/AgentsSchedules/AgentsSchedulesList";
import AgentScheduleNew from "views/Pages/AgentsSchedules/AgentScheduleNew";
import AgentScheduleEdit from "views/Pages/AgentsSchedules/AgentScheduleEdit";
import ProcessDetail from "./views/Pages/Processes/ProcessDetail";
import TrafficViolationCancel from "./views/Pages/TrafficViolation/TrafficViolationCancel";
import ProcessEdit from "./views/Pages/Processes/ProcessEdit";
import TrafficViolationDefer from "./views/Pages/TrafficViolation/TrafficViolationDefer";
import DarvNew from "./views/Pages/Collections/DarvNew";
import DrvList from "views/Pages/Collections/DrvList";
import CollectionsList from "./views/Pages/Collections/CollectionsList";
import ProcessForward from "./views/Pages/Processes/ProcessForward";
import ProcessJudgementPanel from "./views/Pages/Processes/ProcessJudgementPanel";
import ProcessArchive from "./views/Pages/Processes/ProcessArchive";
import ProcessConfirmReceipt from "./views/Pages/Processes/ProcessConfirmReceipt";
import PrintNpsTrial from "views/Pages/Processes/PrintNpsTrial";
import ParkingCredentialsNew from "./views/Pages/ParkingCredentials/ParkingCredentialsNew";
import ParkingCredentialsList from "views/Pages/ParkingCredentials/ParkingCredentialsList";
import ParkingCredentialsEdit from "views/Pages/ParkingCredentials/ParkingCredentialsEdit";
import DocumentsList from "views/Pages/Documents/DocumentsList";
import DocumentsNew from "views/Pages/Documents/DocumentsNew";
import ParkingCredentialsDocumentsList from "views/Pages/ParkingCredentials/Documents/ParkingCredentialsDocumentsList";
import ParkingCredentialsDocumentsNew from "views/Pages/ParkingCredentials/Documents/ParkingCredentialsDocumentsNew";
import PermitteesList from "views/Pages/Permittees/PermitteesList";
import {PermitteesPrintDocumentBatch} from "./views/Pages/Permittees/PrintDocumentInBatch/PermitteesPrintDocumentBatch";
import PermitteesDocumentsList from "views/Pages/Permittees/Documents/PermitteesDocumentsList";
import PermitteesDocumentsNew from "views/Pages/Permittees/Documents/PermitteesDocumentsNew";
import {PermitteesDetail} from "./views/Pages/Permittees/PermitteesDetail";
import {PermitteesPrintLicenseBatch} from "./views/Pages/Permittees/PrintLicenseInBatch/PermitteesPrintLicenseBatch";
import PermitteesNew from "./views/Pages/Permittees/PermitteesNew";
import TransportList from "views/Pages/Transports/TransportList";
import PermitteesDocumentsSendDetran from "views/Pages/Permittees/Documents/PermitteesDocumentsSendDetran";
import SettingsList from "views/Pages/Settings/SettingsList";
import ViolationAllotmentsList from "views/Pages/ViolationAllotmentsValidation/ViolationAllotmentsList";
import TrafficViolationDetails from "views/Pages/TrafficViolation/TrafficViolationDetails";
import NotificationsList from "views/Pages/Notifications/NotificationsList";
import TrafficViolationInformDriver from "views/Pages/TrafficViolation/TrafficViolationInformDriver";
import SendMail from "./views/Pages/Processes/SendMail";
import {ProcessReexamination} from "./views/Pages/Processes/ProcessReexamination";
import {FillFinalDecision} from "./views/Pages/Processes/FillFinalDecision";
import QueriesList from "views/Pages/Queries/QueriesList";
import QueriesVehicle from "views/Pages/Queries/QueriesVehicle";
import QueriesVehicleResult from "views/Pages/Queries/QueriesVehicleResult";
import QueriesDrivers from "views/Pages/Queries/QueriesDrivers";
import QueriesDriversResult from "views/Pages/Queries/QueriesDriversResult";
import NoRecordPrint from "views/Pages/Queries/PrintQueryDocuments/NoRecordPrint";
import SnePrint from "views/Pages/Queries/PrintQueryDocuments/SnePrint";
import TrafficViolationDocumentsList from "views/Pages/TrafficViolation/Documents/TrafficViolationDocumentsList";
import TrafficViolationDocumentsNew from "views/Pages/TrafficViolation/Documents/TrafficViolationDocumentsNew";
import ReportsList from "views/Pages/Reports/ReportsList";
import QualitativeViolationsList from "views/Pages/Reports/QualitativeViolation/QualitativeViolationsList";
import MonthlyReport from "./views/Pages/Reports/MonthlyReportRequestPage";
import ViolationCardPaymentsList from "views/Pages/ViolationCardPayments/ViolationCardPaymentsList";
import ViolationCardPaymentNew from "views/Pages/ViolationCardPayments/ViolationCardPaymentNew";
import AgentTracking from "views/Pages/Reports/AgentTracking/AgentTracking";
import ManagerialList from "views/Pages/Reports/Managerial/ManagerialList";
import UserAccessTimeList from "./views/Pages/Users/UsersAccessTime/UserAccessTimeList";
import UserAccessTimeNew from "./views/Pages/Users/UsersAccessTime/UserAccessTimeNew";
import QueriesSenatranList from "views/Pages/Queries/Senatran/QueriesSenatranList";
import QueriesViolations from "views/Pages/Queries/Senatran/QueriesViolations";
import QueriesViolationsResult from "views/Pages/Queries/Senatran/QueriesViolationsResult";
import QueriesDriversSenatran from "views/Pages/Queries/Senatran/QueriesDriversSenatran";
import QueriesDriversSenatranResult from "views/Pages/Queries/Senatran/QueriesDriversSenatranResult";
import QueriesDriversScoreHistory from "views/Pages/Queries/Senatran/QueriesDriversScoreHistory";
import QueriesDriversScoreHistoryResult from "views/Pages/Queries/Senatran/QueriesDriversScoreHistoryResult";
import QueriesVehicleSenatran from "views/Pages/Queries/Senatran/QueriesVehicleSenatran";
import QueriesVehicleBasicSenatranResult from "views/Pages/Queries/Senatran/QueriesVehicleBasicSenatranResult";
import QueriesVehicleDetailedSenatranResult from "views/Pages/Queries/Senatran/QueriesVehicleDetailedSenatranResult";
import QueriesViolationsPayments from "views/Pages/Queries/Senatran/QueriesViolationsPayments";
import QueriesViolationsPaymentsResult from "views/Pages/Queries/Senatran/QueriesViolationsPaymentsResult";
import QueriesViolationsEvents from "views/Pages/Queries/Senatran/QueriesViolationsEvents";
import QueriesViolationsEventsResult from "views/Pages/Queries/Senatran/QueriesViolationsEventsResult";
import QueriesDriversAddressSenatran from "views/Pages/Queries/Senatran/QueriesDriversAddressSenatran";
import QueriesDriverAddressSenatranResult from "views/Pages/Queries/Senatran/QueriesDriversAddressSenantranResult";
import QueriesDriversBlockers from "views/Pages/Queries/Senatran/QueriesDriversBlockers";
import QueriesDriversBlockersResult from "views/Pages/Queries/Senatran/QueriesDriversBlockersResult";
import QueriesViolationHistory from "views/Pages/Queries/QueriesViolationHistory";
import QueriesViolationHistoryResult from "views/Pages/Queries/QueriesViolationHistoryResult";
import Dashboard from "./views/Pages/Dashboard/Dashboard";
import Statistics from "./views/Pages/Statistics/Statistics";
import BoatList from "./views/Pages/Boat/BoatList";
import PublicBoatList from "./views/Pages/Boat/PublicBoatList";
import PublicBoatDetails from "./views/Pages/Boat/PublicBoatDetails";
import BoatDetails from "./views/Pages/Boat/BoatDetails";
import BoatNew from "./views/Pages/Boat/BoatNew";
import BoatEdit from "./views/Pages/Boat/BoatEdit";
import BoatDrawing from "./views/Pages/Boat/BoatDrawing";
import TrafficViolationPaymentForm from './views/Pages/TrafficViolation/TrafficViolationPaymentForm';
import TrafficViolationConfirmPaymentForm from './views/Pages/TrafficViolation/TrafficViolationConfirmPaymentForm'

const buildConsultasMenuItems = () => {
  const items = [];

  if (ENABLE_CONSULTA_VEICULO_DETRAN_MENU) {
    items.push({
      name: "Consultas de Veículos - DETRAN",
      path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchVehicle,
      component: <QueriesVehicle />,
      layout: ROUTES.panel,
      icon: <FaCar color="inherit" />,
      includeQueryParams: false,
      items: [
        {
          name: "Consultas de Veículos - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchVehicle + ROUTES.searchPlate,
          component: <QueriesVehicleResult searchByPlate={true}/>,
          layout: ROUTES.panel,
          icon: <FaCar color="inherit" />,
          includeQueryParams: false,
          items: []
        },
        {
          name: "Consultas de Veículos - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchVehicle + ROUTES.searchChassis,
          component: <QueriesVehicleResult searchByChassis={true}/>,
          layout: ROUTES.panel,
          icon: <FaCar color="inherit" />,
          includeQueryParams: false,
          items: []
        },
        {
          name: "Consultas de Veículos - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchVehicle + ROUTES.searchSne,
          component: <SnePrint/>,
          layout: ROUTES.panel,
          icon: <FaCar color="inherit" />,
          includeQueryParams: false,
          items: []
        },
        {
          name: "Consultas de Veículos - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchVehicle + ROUTES.searchNoRecord,
          component: <NoRecordPrint/>,
          layout: ROUTES.panel,
          icon: <FaCar color="inherit" />,
          includeQueryParams: false,
          items: []
        }
      ]
    });
  }

  if (ENABLE_CONSULTA_CONDUTORES_DETRAN_MENU) {
    items.push({
      name: "Consulta de Condutores - DETRAN",
      path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDrivers,
      component: <QueriesDrivers />,
      layout: ROUTES.panel,
      icon: <FiUserCheck color="inherit" />,
      includeQueryParams: false,
      permissions: [PERMISSIONS.DRIVER_QUERY],
      items: [
        {
          name: "Consultas de Veículos - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDrivers + ROUTES.searchCpf,
          component: <QueriesDriversResult />,
          layout: ROUTES.panel,
          icon: <FaCar color="inherit" />,
          includeQueryParams: false,
          items: []
        }
      ]
      })
    }
    if (ENABLE_CONSULTA_HISTORICO_MULTAS_CONDUTORES_DETRAN_MENU) {
      items.push({
        name: "Consulta Histórico de Pontuação Condutor - DETRAN",
        path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDriversHistory,
        component: <QueriesDriversScoreHistory />,
        layout: ROUTES.panel,
        icon: <FaHistory color="inherit" />,
        includeQueryParams: false,
        permissions: [PERMISSIONS.DRIVER_QUERY],
        items: [
          {
            name: "Consulta Histórico de Pontuação Condutor - DETRAN",
            path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDriversHistory + ROUTES.searchCpf,
            component: <QueriesDriversScoreHistoryResult />,
            layout: ROUTES.panel,
            icon: <FaHistory color="inherit" />,
            includeQueryParams: false,
            items: []
          }
        ]
      });
    }
    if (ENABLE_CONSULTA_PROCESSO_BLOQUEIO_CONDUTORES_DETRAN_MENU) {
      items.push({
        name: "Consulta Processo de bloqueios - DETRAN",
        path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDriversBlockers,
        component: <QueriesDriversBlockers />,
        layout: ROUTES.panel,
        icon: <FiFileText color="inherit" />,
        includeQueryParams: false,
        permissions: [PERMISSIONS.DRIVER_QUERY],
        items: [
          {
            name: "Consulta Processos de bloqueios - DETRAN",
            path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchDriversBlockers + ROUTES.searchCpf,
            component: <QueriesDriversBlockersResult />,
            layout: ROUTES.panel,
            icon: <FiFileText color="inherit" />,
            includeQueryParams: false,
            items: []
          }
        ]
      });
  }

  if (ENABLE_CONSULTA_HISTORICO_INFRACAO_DETRAN_MENU) {
    items.push({
      name: "Histórico de Infração - DETRAN",
      path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchViolationHistory,
      component: <QueriesViolationHistory />,
      layout: ROUTES.panel,
      icon: <FaHistory color="inherit" />,
      includeQueryParams: false,
      items: [
        {
          name: "Histórico de Infração - DETRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchViolationHistory + ROUTES.searchAit,
          component: <QueriesViolationHistoryResult />,
          layout: ROUTES.panel,
          icon: <FaHistory color="inherit" />,
          includeQueryParams: false,
          items: []
        }
      ]
    });
  }

  if (ENABLE_CONSULTAS_MENU && ENABLE_CONSULTAS_SENATRAN_MENU) {
    items.push({
      name: "Consultas - SENATRAN",
      path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran,
      component: <QueriesSenatranList />,
      layout: ROUTES.panel,
      icon: <FiSearch color="inherit" />,
      includeQueryParams: false,
      items: [
        {
          name: "Consulta de Condutores - SENATRAN",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDrivers,
          component: <QueriesDriversSenatran />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Consulta de Condutores - SENATRAN - CPF",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDrivers + ROUTES.searchCpf,
              component: <QueriesDriversSenatranResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
            },
            {
              name: "Consulta de Condutores - SENATRAN - CNH",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDrivers + ROUTES.searchCnh,
              component: <QueriesDriversSenatranResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
            },
            {
              name: "Consulta de Condutores - SENATRAN - Nome",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDrivers + ROUTES.searchNome,
              component: <QueriesDriversSenatranResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
            },
          ],
        },
        {
          name: "Consulta Básica de Veículos",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranBasicVehicles,
          component: <QueriesVehicleSenatran />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Resultado - Placa (Senatran Básico)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranBasicVehicles + ROUTES.searchPlate,
              component: <QueriesVehicleBasicSenatranResult searchByPlate={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
            {
              name: "Resultado - Chassi (Senatran Básico)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranBasicVehicles + ROUTES.searchChassis,
              component: <QueriesVehicleBasicSenatranResult searchByChassis={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
            {
              name: "Resultado - CPF/CNPJ (Senatran Básico)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranBasicVehicles + ROUTES.searchCpfCnpj,
              component: <QueriesVehicleBasicSenatranResult searchByCpfCnpj={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
          ],
        },
        {
          name: "Consulta Detalhada de Veículos",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDetailedVehicles,
          component: <QueriesVehicleSenatran />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Resultado - Placa (Senatran Detalhado)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDetailedVehicles + ROUTES.searchPlate,
              component: <QueriesVehicleDetailedSenatranResult searchByPlate={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
            {
              name: "Resultado - Chassi (Senatran Detalhado)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDetailedVehicles + ROUTES.searchChassis,
              component: <QueriesVehicleDetailedSenatranResult searchByChassis={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
            {
              name: "Resultado - CPF/CNPJ (Senatran Detalhado)",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranDetailedVehicles + ROUTES.searchCpfCnpj,
              component: <QueriesVehicleDetailedSenatranResult searchByCpfCnpj={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: [],
            },
          ],
        },
        {
          name: "Consulta de Infrações",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolations,
          component: <QueriesViolations />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Consulta de Infrações - Resultado",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolations + ROUTES.searchValor,
              component: <QueriesViolationsResult searchByPlate={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: []
            },
            {
              name: "Consulta de Infrações - Resultado",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolations + ROUTES.searchValor,
              component: <QueriesViolationsResult searchByCpf={true} />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: []
            },
          ]
        },
        {
          name: "Consulta de Pagamento de Infrações",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolationPayments,
          component: <QueriesViolationsPayments />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Consulta de Pagamento de Infrações - Resultado",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolationPayments + ROUTES.searchValor,
              component: <QueriesViolationsPaymentsResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
              items: []
            },
          ]
        },
        {
          name: "Consulta de Endereço de Proprietário de Veículos",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranOwnerAddress,
          component: <QueriesDriversAddressSenatran />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Consulta de Endereço de Proprietário de Veículos - Resultado",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranOwnerAddress + ROUTES.searchPlate,
              component: <QueriesDriverAddressSenatranResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
            }
          ],
        },
        {
          name: "Consulta de Ocorrências de Infrações",
          path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolationEvents,
          component: <QueriesViolationsEvents />,
          layout: ROUTES.panel,
          icon: <FiSearch color="inherit" />,
          includeQueryParams: false,
          items: [
            {
              name: "Consulta de Ocorrências de Infrações - Resultado",
              path: ROUTES.transportManagement + ROUTES.searches + ROUTES.searchSenatran + ROUTES.searchSenatranViolationEvents + ROUTES.searchValor,
              component: <QueriesViolationsEventsResult />,
              layout: ROUTES.panel,
              icon: <FiSearch color="inherit" />,
              includeQueryParams: false,
            }
          ],
        },
      ]
    });
  }

  return items;
};

export const appRoutes = [
  {
    name: "Alertas",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.alerts,
    icon: <FiAlertTriangle color="inherit" />,
    component: <NotificationsList />,
    permissions: [
      PERMISSIONS.PROCESS_CREATION,
      PERMISSIONS.VIOLATION_DOCUMENTS,
      PERMISSIONS.VIEW_ALL_ALERTS],
    items: [],
  },
  {
    name: "Infrações",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.trafficViolations,
    icon: <FiList color="inherit" />,
    component: <TrafficViolationList />,
    permissions: [
      PERMISSIONS.VIOLATION_QUERY,
      PERMISSIONS.ISSUE_AITS_INPUT,
      PERMISSIONS.ISSUE_AITS,
      ],
    items: [
      {
        name: "Novo auto de infração de trânsito",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.addTrafficViolation,
        component: <TrafficViolationNew />,
      },
      {
        name: "Novo auto de infração de trânsito",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.addTrafficViolationVideoMonitoring,
        component: <TrafficViolationNew isVideoMonitoring={true}/>,
      },
      {
        name: "Cancelar Auto de Infração de Trânsito",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.cancelTrafficViolation,
        component: <TrafficViolationCancel />,
      },
      {
        name: "Deferimento de Infração de Trânsito",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.deferTrafficViolation,
        component: <TrafficViolationDefer />,
      },
      {
        name: "Recolhimentos Digitais",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.digitalCollections,
        component: <CollectionsList />,
      },
      {
        name: "Novo DARV Avulso",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.digitalCollections + ROUTES.darvCreate,
        component: <DarvNew />,
      },
      {
        name: "Remoções",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.digitalCollections + ROUTES.drvList,
        component: <DrvList />,
      },
      {
        name: "Detalhes",
        path: ROUTES.transportManagement + ROUTES.trafficViolations + ROUTES.detailsDefault,
        component: <TrafficViolationDetails />,
        layout: ROUTES.panel,
      },
      {
        name: "Indicar Condutor",
        path: ROUTES.transportManagement + ROUTES.trafficViolations + ROUTES.trafficViolationInformDriver,
        component: <TrafficViolationInformDriver />,
        layout: ROUTES.panel,
      },
      {
        name: "Confirmar Pagamento",
        path: ROUTES.transportManagement + ROUTES.trafficViolations + ROUTES.trafficViolationsConfirmPayment,
        component: <TrafficViolationPaymentForm />,
        layout: ROUTES.panel
      },
      {
        name: "Confirmar pagamentos - retorno CNAB 150 / CNAB 240 / CNAB 420",
        path: ROUTES.transportManagement + ROUTES.trafficViolations + ROUTES.violationConfirmPaymentsPath,
        component: <TrafficViolationConfirmPaymentForm />,
        layout: ROUTES.panel
      },
      {
        name: "Documentos",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.trafficViolationsDocuments,
        icon: <FaUsers color="inherit" />,
        component: <TrafficViolationDocumentsList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.trafficViolationsDocuments + ROUTES.trafficViolationDocumentsAdd,
            component: <TrafficViolationDocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.trafficViolationsDocuments + ROUTES.trafficViolationDocumentsEdit,
            component: <TrafficViolationDocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
        ],
      }
    ],
  },
  {
    name: "Dashboard",
    layout: ROUTES.panel,
    path: "/dashboard",
    icon: <FiPieChart color="inherit" />,
    component: <Dashboard />,
    items: [],
    permissions: [PERMISSIONS.MANAGEMENT_REPORTS],
  },
  ...(ENABLE_STATISTICS_MENU
    ? [
        {
          name: "Dashboard Gerencial",
          pageTitle: "Estatísticas Gerenciais",
          layout: ROUTES.panel,
          path: ROUTES.statistics,
          icon: <FiBarChart2 color="inherit" />,
          component: <Statistics />,
          items: [],
          permissions: [PERMISSIONS.MANAGEMENT_REPORTS],
        },
      ]
    : []),
  {
    name: "BOST",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.boats,
    icon: <FaCarCrash color="inherit" />,
    collapse: true,
    permissions: [PERMISSIONS.ADMINISTRATOR, PROFILES.agent],
    items: [
      {
        name: "Boletins de Sinistro",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.boats,
        icon: <FaWpforms color="inherit" />,
        component: <BoatList />,
        permissions: [PERMISSIONS.ADMINISTRATOR, PROFILES.agent],
        items: [
          {
            name: "Novo",
            layout: ROUTES.panel,
            path: ROUTES.transportManagement + ROUTES.boats + ROUTES.boatsAdd,
            component: <BoatNew />,
          },
          {
            name: "Editar",
            layout: ROUTES.panel,
            path: ROUTES.transportManagement + ROUTES.boats + ROUTES.boatsEdit,
            component: <BoatEdit />,
          },
          {
            name: "Detalhes",
            layout: ROUTES.panel,
            path: ROUTES.transportManagement + ROUTES.boats + ROUTES.boatsDetails,
            component: <BoatDetails />,
          },
          {
            name: "Desenho",
            layout: ROUTES.panel,
            path: ROUTES.transportManagement + ROUTES.boats + ROUTES.boatsDrawing,
            component: <BoatDrawing />,
          }
        ]
      },
      {
        name: "Boletins Públicos",
        layout: ROUTES.panel,
        path: ROUTES.publicBoats,
        icon: <FaUser color="inherit" />,
        component: <PublicBoatList />,
        permissions: [PERMISSIONS.ADMINISTRATOR, PROFILES.agent],
        items: [
          {
            name: "Detalhes",
            layout: ROUTES.panel,
            path: ROUTES.publicBoatDetails,
            component: <PublicBoatDetails />,
          },
        ],
      }
    ]
  },
  ...(ENABLE_CARTOES_MENU ? [{
    name: "Cartões",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.violationCardPayments,
    icon: <FiCreditCard color="inherit" />,
    component: <ViolationCardPaymentsList />,
    items: [
      {
        name: "Novo Pagamento de Infração",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.violationCardPayments + ROUTES.violationCardPaymentsNew,
        component: <ViolationCardPaymentNew />,
      },
      {
        name: "Editar Pagamento de Infração",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.violationCardPayments + ROUTES.violationCardPaymentsEdit,
        component: <ViolationCardPaymentNew />,
      },
    ],
  }] : []),
  ...(ENABLE_CONSULTAS_MENU ? [{
    name: "Consultas",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.searches,
    icon: <FiSearch color="inherit" />,
    ignoreRoute: false,
    collapse: true,
    includeQueryParams: false,
    component: <QueriesList />,
    items: buildConsultasMenuItems(),
  }] : []),
  {
    name: "Lotes",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.violationAllotments,
    icon: <FiCheck color="inherit" />,
    component: <ViolationAllotmentsList />,
    ignoreRoute: false,
    collapse: true,
    permissions: [
      PERMISSIONS.VIOLATION_VALIDATION,
      PERMISSIONS.PRINT_BATCHES,
    ],
    items:
      [
        {
          name: "violation-allotments.validation.title",
          layout: ROUTES.panel,
          path: ROUTES.transportManagement + ROUTES.violationAllotmentsValidation,
          icon: <CheckCircleIcon color="inherit" />,
          component: <ViolationAllotmentsValidationList />,
          items: [
            {
              name: "violation-allotments.validate.title",
              layout: ROUTES.panel,
              path: ROUTES.transportManagement + ROUTES.violationAllotmentsViolations,
              component: <ViolationAllotmentsViolationList />,
            },
            {
              name: "violation-allotments.validate.title",
              layout: ROUTES.panel,
              path: ROUTES.transportManagement + ROUTES.violationAllotmentsValidate,
              component: <ViolationAllotmentValidate />,
            },
            {
              name: "violation-allotments.validate.title",
              layout: ROUTES.panel,
              path: ROUTES.transportManagement + ROUTES.violationAllotmentsValidateViolation,
              component: <ViolationAllotmentValidate />,
            },
          ],
        },
        {
          name: "Impressão NAs",
          layout: ROUTES.panel,
          path: ROUTES.transportManagement + ROUTES.violationAllotments + ROUTES.violationAllotmentsPrintingNAs,
          icon: <IconWithBadge icon={FiPrinter} label="NAs" />,
          component: <PrintNAsList />,
          permissions: [
            PERMISSIONS.PRINT_BATCHES,
          ],
          items: [],
        },
        {
          name: "Impressão NPs",
          layout: ROUTES.panel,
          path: ROUTES.transportManagement + ROUTES.violationAllotments + ROUTES.violationAllotmentsPrintingNPs,
          component: <PrintNPsList />,
          permissions: [
            PERMISSIONS.PRINT_BATCHES,
          ],
          icon: <IconWithBadge icon={FiPrinter} label="NPs" />,
          items: [],
        }
      ],
  },
  {
    name: "Processos",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.processes,
    icon: <FaBalanceScale color="inherit" />,
    component: <ProcessesList />,
    permissions: [
      PERMISSIONS.PROCESS_CREATION,
      PERMISSIONS.PROCESS_SERVICE,
      PERMISSIONS.PROCESS_ALLOCATION,
      PERMISSIONS.FILL_FINAL_DECISION,
      ],
    items: [
      {
        name: "Novo Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesAdd,
        component: <ProcessNew />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Editar Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.editDefault,
        component: <ProcessEdit />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Detalhes Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.detailsDefault,
        component: <ProcessDetail />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Encaminhar Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesForward,
        component: <ProcessForward />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Julgar Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.judgeProcesses,
        component: <ProcessJudgementPanel />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Arquivar Processo",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesArchive,
        component: <ProcessArchive />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Confirmar Recebimento",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesConfirmReceipt,
        component: <ProcessConfirmReceipt />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Enviar Resultado",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesSendEmail,
        component: <SendMail />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Reexaminar",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesReexamination,
        component: <ProcessReexamination />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Decisão Final",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processesFinalDecision,
        component: <FillFinalDecision />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Imprimir NPs para Relato e Julgamento",
        path: ROUTES.transportManagement + ROUTES.processes + ROUTES.processPrintNpsTrial,
        component: <PrintNpsTrial />,
        layout: ROUTES.panel,
        items: [],
      }
    ],
  },
  {
    name: "Transportes",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.transports,
    icon: <FaBus color="inherit" />,
    component: <TransportList />,
    ignoreRoute: false,
    collapse: true,
    permissions: [PERMISSIONS.PERMIT_CREATION],
    items: [
      {
        name: "Permissionários",
        path: ROUTES.transportManagement + ROUTES.permittee,
        component: <PermitteesList />,
        layout: ROUTES.panel,
        icon: <FaTaxi color="inherit" />,
        permissions: [PERMISSIONS.PERMIT_CREATION],
        items: [
          {
            name: "Imprimir Documento de Lote",
            path: ROUTES.transportManagement + ROUTES.permittee + ROUTES.permitteePrintDocumentBatch,
            component: <PermitteesPrintDocumentBatch/>,
            layout: ROUTES.panel,
            icon: <FaTaxi color="inherit" />,
            items: []
          },
          {
            name: "Imprimir Alvarás em Lote",
            path: ROUTES.transportManagement + ROUTES.permittee + ROUTES.permitteePrintLicenseBatch,
            component: <PermitteesPrintLicenseBatch/>,
            layout: ROUTES.panel,
            icon: <FaTaxi color="inherit" />,
            items: []
          },
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.permittee + ROUTES.permitteesAdd,
            component: <PermitteesNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.permittee + ROUTES.editDefault,
            component: <PermitteesNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Detalhes Permissionários",
            path: ROUTES.transportManagement + ROUTES.permittee + ROUTES.detailsDefault,
            component: <PermitteesDetail />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Documentos Adicionais",
            layout: ROUTES.panel,
            path: ROUTES.management + ROUTES.documents ,
            icon: <FaUsers color="inherit" />,
            queryParams: { parent_type: "permissionarios" },
            component: <DocumentsList />,
            items: [
              {
                name: "Adicionar",
                path: ROUTES.management + ROUTES.documents + ROUTES.documentsAdd,
                component: <DocumentsNew />,
                queryParams: { parent_type: "permissionarios" },
                layout: ROUTES.panel,
                items: [],
              },
              {
                name: "Editar",
                path: ROUTES.management + ROUTES.documents + ROUTES.documentsEdit,
                component: <DocumentsNew />,
                queryParams: { parent_type: "permissionarios" },
                layout: ROUTES.panel,
                items: [],
              },
            ],
          },
          {
            name: "Documentos",
            layout: ROUTES.panel,
            path: ROUTES.transportManagement + ROUTES.permitteeDocuments,
            icon: <FaUsers color="inherit" />,
            component: <PermitteesDocumentsList />,
            items: [
              {
                name: "Adicionar",
                path: ROUTES.transportManagement + ROUTES.permitteeDocuments + ROUTES.permitteeDocumentAdd,
                component: <PermitteesDocumentsNew />,
                layout: ROUTES.panel,
                items: [],
              },
              {
                name: "Editar",
                path: ROUTES.transportManagement + ROUTES.permitteeDocuments + ROUTES.permitteeDocumentEdit,
                component: <PermitteesDocumentsNew />,
                layout: ROUTES.panel,
                items: [],
              },
              {
                name: "Enviar para o Detran",
                path: ROUTES.transportManagement + ROUTES.permitteeDocuments + ROUTES.permitteeDocumentSendDetran,
                component: <PermitteesDocumentsSendDetran />,
                layout: ROUTES.panel,
                items: [],
              }
            ],
          }
        ]
      }
    ],
  },
  {
    name: "Credenciais",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.parkingCredentials,
    icon: <FaWheelchair color="inherit" />,
    component: <ParkingCredentialsList />,
    permissions: PERMISSIONS.CREDENTIAL_CREATION,
    items: [
      {
        name: "Nova Credencial",
        path: ROUTES.transportManagement + ROUTES.parkingCredentials + ROUTES.parkingCredentialsAdd,
        component: <ParkingCredentialsNew />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Editar Credencial",
        path: ROUTES.transportManagement + ROUTES.parkingCredentials + ROUTES.editDefault,
        component: <ParkingCredentialsEdit />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Documentos Adicionais",
        layout: ROUTES.panel,
        path: ROUTES.management + ROUTES.documents,
        icon: <FaUsers color="inherit" />,
        queryParams: { parent_type: "credenciais-estacionamento" },
        component: <DocumentsList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.management + ROUTES.documents + ROUTES.documentsAdd,
            queryParams: { parent_type: "credenciais-estacionamento" },
            component: <DocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.management + ROUTES.documents + ROUTES.documentsEdit,
            queryParams: { parent_type: "credenciais-estacionamento" },
            component: <DocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
        ],
      },
      {
        name: "Documentos",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.parkingCredentialsDocuments,
        icon: <FaUsers color="inherit" />,
        component: <ParkingCredentialsDocumentsList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.parkingCredentialsDocuments + ROUTES.parkingCredentialsDocumentAdd,
            component: <ParkingCredentialsDocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.parkingCredentialsDocuments + ROUTES.parkingCredentialsDocumentEdit,
            component: <ParkingCredentialsDocumentsNew />,
            layout: ROUTES.panel,
            items: [],
          },
        ],
      }
    ],
  },
  {
    name: "Relatórios",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.reports,
    icon: <FiBook color="inherit" />,
    component: <ReportsList />,
    permissions: [
      PERMISSIONS.MANAGEMENT_REPORTS,
      PERMISSIONS.FINANCIAL_REPORTS,
      PERMISSIONS.AGENT_TRACKING,
      PERMISSIONS.PERMIT_REPORTS,
      PERMISSIONS.VIOLATION_REPORTS,
    ],
    items: [
      {
        name: "Rastreamento de Agentes",
        path: ROUTES.transportManagement + ROUTES.reports + ROUTES.reportsAgentTracking,
        component: <AgentTracking />,
        layout: ROUTES.panel,
        permissions: [
          PERMISSIONS.AGENT_TRACKING,
        ],
        items: [],
      },
      {
        name: "Gerencial",
        path: ROUTES.transportManagement + ROUTES.reports + ROUTES.reportsManagerial,
        component: <ManagerialList />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Qualitativo de Infrações",
        path: ROUTES.transportManagement + ROUTES.reports + ROUTES.reportsViolationsQualitative,
        component: <QualitativeViolationsList />,
        layout: ROUTES.panel,
        items: [],
      },
      {
        name: "Relatório",
        path: ROUTES.transportManagement + ROUTES.reports + ROUTES.monthlyReport,
        component: <MonthlyReport />,
        layout: ROUTES.panel,
        items: [],
      }
    ],
  },
  {
    name: "Ajuda",
    url: "https://docs.sgmt.norteware.com.br/",
    icon: <FiHelpCircle color="inherit" />,
    items: [],
  },
  {
    name: "Configurações",
    layout: ROUTES.panel,
    path: ROUTES.transportManagement + ROUTES.settings,
    collapse: true,
    ignoreRoute: false,
    component: <SettingsList />,
    icon: <SettingsIcon color="inherit" />,
    permissions: [
      PERMISSIONS.USER_MANAGEMENT,
      PERMISSIONS.EQUIPMENT_MANAGEMENT,
      PERMISSIONS.CAMERA_MANAGEMENT,
      PERMISSIONS.BREATHALYZER_MANAGEMENT,
    ],
    items: [
      {
        name: "Parâmetros",
        layout: ROUTES.panel,
        path: ROUTES.management + ROUTES.parameters,
        icon: <FaBars color="inherit" />,
        component: <ParametersList />,
        items: [
          {
            name: "Editar",
            path: ROUTES.management + ROUTES.parameters + ROUTES.parametersEdit,
            component: <ParametersEdit />,
            layout: ROUTES.panel,
            items: [],
          }
        ],
      },
      {
        name: "Câmeras",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.cameras,
        icon: <FaVideo color="inherit" />,
        component: <CamerasList />,
        items:
          [
            {
              name: "Adicionar",
              path: ROUTES.transportManagement + ROUTES.cameras + ROUTES.camerasAdd,
              component: <CameraNew />,
              layout: ROUTES.panel,
              items: [],
            },
            {
              name: "Editar",
              path: ROUTES.transportManagement + ROUTES.cameras + ROUTES.camerasEdit,
              component: <CameraEdit />,
              layout: ROUTES.panel,
              items: [],
            }
          ],
      },
      {
        name: "Etilômetros",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.breathalyzers,
        icon: <FaMobile color="inherit" />,
        component: <BreathalyzersList />,
        items: [{
          name: "Adicionar",
          path: ROUTES.transportManagement + ROUTES.breathalyzers + ROUTES.breathalyzersAdd,
          component: <BreathalyzerNew />,
          layout: ROUTES.panel,
          items: [],
        },
        {
          name: "Editar",
          path: ROUTES.transportManagement + ROUTES.breathalyzers + ROUTES.breathalyzersEdit,
          component: <BreathalyzerEdit />,
          layout: ROUTES.panel,
          items: [],
        }
        ],
      },
      {
        name: "settings.equipment.title",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.equipments,
        icon: <FaRoad color="inherit" />,
        component: <EquipmentsList />,
        items: [
          {
            name: "settings.equipment.create.title",
            path: ROUTES.transportManagement + ROUTES.equipmentsAdd,
            component: <EquipmentNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "settings.equipment.edit.title",
            path: ROUTES.transportManagement + ROUTES.equipmentsEdit,
            component: <EquipmentNew />,
            layout: ROUTES.panel,
            items: [],
          },
        ],
      },
      {
        name: "Blocos de Autos de Infração (AIT)",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.aitBlocks,
        icon: <FaBook color="inherit" />,
        component: <AitBlocksList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.aitBlocks + ROUTES.aitBlocksAdd,
            component: <AitBlockNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.aitBlocks + ROUTES.aitBlocksEdit,
            component: <AitBlockNew />,
            layout: ROUTES.panel,
            items: [],
          }
        ],
      },
      {
        name: "Usuários",
        layout: ROUTES.panel,
        path: ROUTES.management + ROUTES.users,
        icon: <FaUsers color="inherit" />,
        component: <UserList />,
        items: [
          {
            name: "Documentos",
            layout: ROUTES.panel,
            path: ROUTES.management + ROUTES.documents,
            icon: <FaUsers color="inherit" />,
            queryParams: { parent_type: "usuarios" },
            component: <DocumentsList />,
            items: [
              {
                name: "Adicionar",
                path: ROUTES.management + ROUTES.documents + ROUTES.documentsAdd,
                component: <DocumentsNew />,
                queryParams: { parent_type: "usuarios" },
                layout: ROUTES.panel,
                items: [],
              },
              {
                name: "Editar",
                path: ROUTES.management + ROUTES.documents + ROUTES.documentsEdit,
                component: <DocumentsNew />,
                queryParams: { parent_type: "usuarios" },
                layout: ROUTES.panel,
                items: [],
              },
            ],
          },
          {
            name: "Horários de acesso",
            layout: ROUTES.panel,
            path: ROUTES.management + ROUTES.usersAccessTime,
            icon: <FaClock color="inherit" />,
            component: <UserAccessTimeList />,
            items: [
              {
                name: "Adicionar",
                path: ROUTES.management + ROUTES.usersAccessTime + ROUTES.usersAccessTimeAdd,
                component: <UserAccessTimeNew />,
                layout: ROUTES.panel,
                items: [],
              },
              {
                name: "Editar",
                path: ROUTES.management + ROUTES.usersAccessTime + ROUTES.usersAccessTimeEdit,
                component: <UserAccessTimeNew />,
                layout: ROUTES.panel,
                items: [],
              }
            ],
          },
          {
            name: "Adicionar",
            path: ROUTES.management + ROUTES.users + ROUTES.usersAdd,
            component: <UserNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.management + ROUTES.users + ROUTES.usersEdit,
            component: <UserNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Detalhes",
            path: ROUTES.management + ROUTES.users + ROUTES.usersDetails,
            component: <UserDetails />,
            layout: ROUTES.panel,
            items: [],
          }
        ],
      },
      {
        name: "Agentes",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.agents,
        icon: <FaQq color="inherit" />,
        component: <AgentsList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.agents + ROUTES.agentsAdd,
            component: <AgentNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.agents + ROUTES.agentsEdit,
            component: <AgentNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Detalhes",
            path: ROUTES.transportManagement + ROUTES.agents + ROUTES.agentsDetails,
            component: <AgentDetails />,
            layout: ROUTES.panel,
            items: [],
          }
        ],
      },
      {
        name: "Escalas de Agentes",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.agentsSchedules,
        icon: <FaClock color="inherit" />,
        component: <AgentsSchedulesList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.transportManagement + ROUTES.agentsSchedules + ROUTES.agentsSchedulesAdd,
            component: <AgentScheduleNew />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.transportManagement + ROUTES.agentsSchedules + ROUTES.agentsSchedulesEdit,
            component: <AgentScheduleEdit />,
            layout: ROUTES.panel,
            items: [],
          },
        ],
      },
      {
        name: "Pessoas",
        layout: ROUTES.panel,
        path: ROUTES.management + ROUTES.person,
        icon: <PersonIcon color="inherit" />,
        component: <PersonList />,
        items: [
          {
            name: "Adicionar",
            path: ROUTES.management + ROUTES.person + ROUTES.personAdd,
            component: <PersonEditor />,
            layout: ROUTES.panel,
            items: [],
          },
          {
            name: "Editar",
            path: ROUTES.management + ROUTES.person + ROUTES.personEdit,
            component: <PersonEditor />,
            layout: ROUTES.panel,
            items: [],
          }
        ]
      },
      {
        name: "Auditoria",
        layout: ROUTES.panel,
        path: ROUTES.management + ROUTES.audits,
        icon: <FaSearch color="inherit" />,
        component: <AuditList />,
        items: [],
      },
    ],
  },
]

const dashRoutes = [
  {
    name: "PAGES",
    category: "pages",
    items: [
      {
        name: "Applications",
        path: "/applications",
        icon: <StatsIcon color="inherit" />,
        collapse: true,
        items: [
          {
            name: "Data Tables",
            path: "/applications/data-tables",
            authIcon: <PersonIcon color="inherit" />,
            component: <DataTables />,
            layout: "/admin",
          },
        ],
      },
      {
        name: "Authentication",
        path: ROUTES.login,
        icon: <PersonIcon color="inherit" />,
        collapse: true,
        items: [
          {
            name: "Sign In",
            path: "/auth",
            collapse: true,
            authIcon: <DocumentIcon color="inherit" />,
            items: [
              {
                name: "Cover",
                component: <SignInCover />,
                path: "/login",
                layout: "/auth",
              }
            ],
          },
        ],
      },
    ],
  },
  {
    name: "Atalhos",
    category: "shortcuts",
    items: [
      {
        name: "Sign In",
        layout: '/auth',
        path: '/login',
        icon: <PersonIcon color="inherit" />,
      },
      {
        name: "Painel GOTT",
        layout: ROUTES.panel,
        path: ROUTES.transportManagement + ROUTES.trafficViolations,
        icon: <DocumentIcon color="inherit" />,
      },
    ]
  }
];

export default dashRoutes;
